import { onMounted, onUnmounted, readonly } from "vue";

// Should be in sync with SCSS variables (variables.scss)
const DesktopMinScreenWidth = 1280;
const TabletMaxScreenWidth = 768;
const PhoneMaxScreenWidth = 576;

export function useScreenSize() {
  const screenWidth = ref(window.innerWidth);

  const isDesktop = computed(() => screenWidth.value > DesktopMinScreenWidth);
  const isTablet = computed(() => screenWidth.value <= TabletMaxScreenWidth && screenWidth.value > PhoneMaxScreenWidth);
  const isPhone = computed(() => screenWidth.value <= PhoneMaxScreenWidth);

  onMounted(() => window.addEventListener("resize", updateScreenWidth));
  onUnmounted(() => window.removeEventListener("resize", updateScreenWidth));

  const updateScreenWidth = () => (screenWidth.value = window.innerWidth);

  return {
    isDesktop,
    isTablet,
    isPhone,

    screenWidth: readonly(screenWidth),
  };
}
